module.exports = __webpack_public_path__ + "static/media/iphone_12_green.71122612.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_green.png
// module id = 2090
// module chunks = 0